import { getListItemStyles } from "./ListItem.styles";
import { Icon } from "../../atoms/Icon";
import type { ListItemProps } from "./ListItem.types";
import React from "react";

export const ListItem = ({ label, icon, children, onClick, ...props }: ListItemProps) => {
  const isDisabled = props.disabled || false;
  const styles = getListItemStyles({
    isDisabled,
  });

  return (
    <button
      {...props}
      type="button"
      className={styles.listItem}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (isDisabled) {
          e.preventDefault();
          return;
        }
        if (onClick) {
          onClick(e);
        }
      }}
    >
      {children ? (
        children
      ) : (
        <React.Fragment>
          {icon && <Icon name={icon} />}
          <span className={styles.label}>{label}</span>
        </React.Fragment>
      )}
    </button>
  );
};
